import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-duoshilianyun",
  "use": "icon-duoshilianyun-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"icon-duoshilianyun\"><path d=\"M14.498 10.997h-3.005v1.007H0v.992h11.493v1.006h3.005v-1.006H16v-.992h-1.502v-1.007zM12.5 12.996v-.992h.992v.992H12.5zM9.495 5.499h-2.99v1.006H0v.992h6.505v1.006h2.99V7.497H16v-.992H9.495V5.499zm-.992 1.998H7.497v-.992h1.006v.992zm-4.01-6.49V0h-2.99v1.006H0v.992h1.502v1.006h2.99V1.998H16v-.992H4.492zm-1.999.991v-.992H3.5v.992H2.494z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/duoshilianyun.svg
// module id = 458
// module chunks = 4